import { encode } from "../Component/JWT/Formatt";

// Maps a NotificationLog "notificationType" to the page it should open, reusing
// the same deep-link routes already used elsewhere in the app (e.g. dashboard
// widgets linking into a work order). Add more types here as their routes are confirmed.
const ROUTE_BUILDERS = {
  "work order assigned": (referenceId) => `/workorderview?id=${encode(referenceId)}`,
};

export const getNotificationRoute = (notificationType, referenceId) => {
  if (!notificationType || !referenceId) return null;
  const buildRoute = ROUTE_BUILDERS[notificationType.toLowerCase()];
  return buildRoute ? buildRoute(referenceId) : null;
};
